((homepageTopCategories, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homeTopCategoriesCarousel = $('.js-home-top-categories--category-list-slider');
  };

  const bindUIActions = () => {
    $dom.homeTopCategoriesCarousel.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            centerMode: true,
            centerPadding: '50px',
          },
        },
      ],
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageTopCategories.init = init;
})((window.homepageTopCategories = window.homepageTopCategories || {}), jQuery);
